import './ShareProjectRemoveModal.scss';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'src/modules/common/components/Button';
import { ModalBody } from 'src/modules/common/components/ModalBody';
import { ModalFooter } from 'src/modules/common/components/ModalFooter';
import { ModalHeader } from 'src/modules/common/components/ModalHeader';
import { SharedUser } from 'src/modules/sharing-projects/types/SharedUser';

type Props = {
  readonly user: SharedUser;
  readonly submitting: boolean;

  readonly onSubmit: (data: SharedUser) => void;
  readonly onCancel: () => void;
};

export const ShareProjectChangeOwnerModal = ({
  user,
  submitting,
  onSubmit,
  onCancel,
}: Props): React.ReactElement => (
  <>
    <ModalHeader
      title={<FormattedMessage id="shareProject/ownerModal/title"/>}
      handleClose={onCancel}
      danger={true}
    />

    <ModalBody danger={true}>
      <div className="bp-share-project-remove-modal__body">
        <FormattedMessage
          id="shareProject/ownerModal/body"
          values={{
            firstName: user.firstName,
            lastName: user.lastName,
          }}
        />
      </div>
    </ModalBody>

    <ModalFooter>
      <Button
        kind="secondary"
        fullWidth={true}
        onClick={onCancel}
        autoFocus={true}
        disabled={submitting}
      >
        <FormattedMessage id="shareProject/ownerModal/action/cancel"/>
      </Button>

      <Button
        disabled={submitting}
        kind="danger"
        fullWidth={true}
        onClick={() => onSubmit(user)}
        loading={submitting}
      >
        <FormattedMessage id="shareProject/ownerModal/action/submit"/>
      </Button>
    </ModalFooter>
  </>
);
